import {BASE_URL} from "app/config/env";

const prefix = `${BASE_URL}/panel`;

export const loggedUserUrls = {
  'app.loggedUser.tasks' : `${BASE_URL}/my-tasks`,
}
